<template>
  <div class="background">
    <svg class="title-text" viewBox="0 0 162.5 24">
      <text class="title" x="81.25" y="24" font-size="22" text-anchor="middle">
        Volume Marker
      </text>
    </svg>
    <button class="button" @click="buttonClick"></button>
  </div>
</template>

<script>
export default {
  name: 'VolumeButton',
  methods: {
    buttonClick() {
      this.$emit('add-volume-marker')
    }
  }
}
</script>

<style scoped>
text {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.background {
  display: grid;
  grid-template-rows: 25% 75%;
}
svg {
  width: 100%;
}
.title-text {
  grid-row: 1;
  fill: #00413b;
}
.button {
  grid-row: 2;
  background-color: transparent;
  background-image: url('../assets/volume.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 65%;
  border: none;
}
button:focus {
  outline: none;
}
</style>
